export default {
  BOSS: 'boss',
  MANAGER: 'manager',
  DIRECTOR: 'director',
}
